module.exports = __webpack_public_path__ + "img/cat-empty-ahorros.019dc8e2.svg";